<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right">
            <div class="dish-config-container">
                <div class="page-title">
                    <h2>{{ departmentName ? (departmentName + '-教师数量配置') : '教师数量概况' }}</h2>
                </div>

                <div v-if="loading" class="loading-container" style="min-height: 300px;">
                    <div class="loading-content">
                        <div class="loading-text">正在加载数据...</div>
                    </div>
                </div>

                <el-card class="config-card" v-else-if="DepartmentId > 0">
                    <div class="config-form">
                        <el-form :model="formData" :rules="rules" ref="dataForm" label-width="200px">
                            <el-form-item label="本校区教职工总数" prop="total">
                                <el-input-number v-model="formData.total" :min="0" controls-position="right"
                                    class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">人</span>
                            </el-form-item>

                            <el-form-item label="其中：男教师人数" prop="male">
                                <el-input-number v-model="formData.male" :min="0" controls-position="right"
                                    class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">人</span>
                            </el-form-item>

                            <el-form-item label="其中：女教师人数" prop="female">
                                <el-input-number v-model="formData.female" :min="0" controls-position="right"
                                    class="elegant-input-number">
                                </el-input-number>
                                <span class="unit-text">人</span>
                            </el-form-item>

                        </el-form>
                    </div>

                    <div class="button-group">
                        <el-button type="primary" @click="handleSave" :loading="saving">保存配置</el-button>
                    </div>
                </el-card>

                <!-- 未选择部门时的提示 -->
                <div v-else class="no-department-tip">
                    <p>请选择左侧的学校或部门来配置教师数据概况</p>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane'
import { getTeacherDataOverviewConfig, saveTeacherDataOverviewConfig } from '../../../api/modules/big-screen';
export default {
    name: 'TeacherDataOverview',
    components: { DepartmentPane },
    data() {
        // 自定义检验：男女相加等于总数提醒（仅作演示，不强阻断保存可以设为 warning，这里做基础校验）
        const validateSum = (rule, value, callback) => {
            const sum = this.formData.male + this.formData.female;
            if (sum > this.formData.total) {
                callback(new Error('男女人数之和不能大于总教职工数！'));
            } else {
                callback();
            }
        };

        return {
            DepartmentId: 0,
            saving: false,
            loading: false,
            departmentName: '',
            formData: {
                total: 0,
                male: 0,
                female: 0
            },
            rules: {
                total: [
                    { required: true, message: '不能为空', trigger: 'change' },
                    { validator: validateSum, trigger: 'change' }
                ],
                male: [
                    { required: true, message: '不能为空', trigger: 'change' },
                    { validator: validateSum, trigger: 'change' }
                ],
                female: [
                    { required: true, message: '不能为空', trigger: 'change' },
                    { validator: validateSum, trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value;
            this.departmentName = data.label || '';
            this.getConfigData();
        },
        getConfigData() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        getConfigData() {
            this.loading = true;
            getTeacherDataOverviewConfig({ departmentId: this.DepartmentId }).then(res => {
                this.loading = false;
                if (res && res.data.response) {
                    var d = res.data.response;
                    this.formData.total = d.Total || 0;
                    this.formData.male = d.Male || 0;
                    this.formData.female = d.Female || 0;
                }
            }).catch(() => {
                this.loading = false;
                this.$message.error('获取配置失败，请稍后重试');
            });
        },
        handleSave() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.saving = true;
                    var saveData = {
                        SchoolId: this.DepartmentId,
                        Total: this.formData.total,
                        Male: this.formData.male,
                        Female: this.formData.female
                    };
                    saveTeacherDataOverviewConfig(saveData).then(res => {
                        this.saving = false;
                        if (res && res.data.success) {
                            this.$message.success('数据已成功保存');
                            this.getConfigData();
                        } else {
                            this.$message.error(res && res.data.msg || '保存失败，请稍后重试');
                        }
                    }).catch(() => {
                        this.saving = false;
                        this.$message.error('保存失败，请稍后重试');
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.dish-config-container {
    max-width: 800px;
    margin: 0;
    padding: 20px;
}

.page-title {
    margin-bottom: 20px;
}

.page-title h2 {
    font-size: 20px;
    margin: 0;
    color: #1a1f36;
    font-weight: 600;
}

.config-card {
    margin-bottom: 20px;
}

.config-form {
    margin-bottom: 10px;
}

.config-form /deep/ .el-form-item {
    margin-bottom: 28px;
}

.config-form /deep/ .el-form-item__label {
    color: #666;
    font-weight: 500;
    font-size: 14px;
    padding-right: 20px;
}

.button-group {
    display: flex;
    justify-content: flex-start;
    padding-top: 20px;
    border-top: 1px solid #e8e8e8;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
}

.loading-content {
    text-align: center;
}

.loading-text {
    margin-top: 10px;
    color: #666;
}

.no-department-tip {
    background-color: #fff;
    border-radius: 4px;
    padding: 60px 20px;
    text-align: center;
    color: #999;
    border: 1px solid #e8e8e8;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 输入框规范化 */
.elegant-input-number {
    width: 200px;
}

.elegant-input-number /deep/ .el-input__inner {
    border-radius: 4px;
    text-align: left;
    padding-left: 15px;
}

.unit-text {
    margin-left: 12px;
    color: #606266;
    font-size: 14px;
}
</style>
